import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import get from 'lodash/get';

import Button from 'rebook/apps/base/components/Button';
import CountdownTimer from 'rebook/apps/base/components/CountdownTimer/index';
import Form, { FormRow, FormControl } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import * as UserActions from 'rebook/apps/users/actions/UserActions';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import mainStyles from 'rebook/apps/users/views/UserSettingsView/style.scss';

import styles from './style.scss';


class UserSettingsEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      errorList: {},
      isChangedForm: false,
      isFinished: false,
      isDisabled: false,
      isInProgress: false,
      isTimerActive: false,
    };
  }

  handleSubmit(submit) {
    const { isChangedForm, isFinished, isInProgress } = this.state;
    if (isInProgress) {
      return;
    }
    if ((isChangedForm || isFinished) && !(isChangedForm && isFinished)) {
      this.setState({ isInProgress: true });
      submit(validateForm(this.state.form));
    }
    else {
      this.setState({
        isChangedForm: true,
        isFinished: false,
        isTimerActive: false,
      });
    }
  }

  handleSuccess() {
    this.setState({
      errorList: {},
      isInProgress: false,
      isTimerActive: true,
      isFinished: true,
    });
    ga('send', 'event', {
      eventCategory: 'Profile',
      eventAction: 'AddEmail',
    });
    yaMetrikaReachGoal('AddEmail');
  }

  handleError(errorList) {
    this.setState({
      errorList,
      isInProgress: false,
      isTimerActive: false,
      isFinished: true,
    });
  }

  handleTimerFinished() {
    this.setState({ isTimerActive: false });
  }

  updateFormField(input) {
    this.setState(
      (prevState) => {
        return {
          errorList: {},
          isChangedForm: true,
          isFinished: false,
          form: {
            ...prevState.form,
            ...input,
          },
        };
      }
    );
  }

  handleResendMail() {
    const { form } = this.state;
    const userEmail = get(form, 'email.value', null);
    this.setState({ isInProgress: true });
    this.props.UserActions.changeUserEmail(userEmail)
      .then(
        () => {
          this.setState({
            errorList: {},
            isInProgress: false,
            isTimerActive: true,
            isFinished: true,
          });
        }
      )
      .catch(
        () => {
          this.setState({
            errorList,
            isInProgress: false,
            isTimerActive: false,
            isFinished: true,
          });
        }
      );
  }

  render() {
    const { user } = this.props;
    const { isFinished, isChangedForm, isInProgress, isTimerActive, errorList, form } = this.state;
    const userEmail = get(user, 'email', false);
    const isFakeUserEmail = get(user, 'is_fake_email', false);
    const isError = get(errorList, 'email.length', 0) > 0;
    const isShowWarningMessage = isChangedForm && isFinished && !isError;
    const isShowUserEmail = !isShowWarningMessage && userEmail;
    const isShowEmailInput = isChangedForm && !isFinished || isError;
    const isShowCountDownTimer = isChangedForm && isTimerActive;
    const isShowResendButton = isShowWarningMessage && !isTimerActive;

    return (
      <div className={classNames(mainStyles.billetContainer, styles.emailSettings)}>
        <div className="title-2">Электронная почта</div>
        <div className={styles.description}>
          {isShowWarningMessage && (
            <div className={styles.message}>
              <div className={styles.messageHeader}>
                <span>
                  Подтвердите E-mail
                </span>
              </div>
              <div className={styles.messageTitle}>
                <span>
                  Письмо со ссылкой мы отправили на указанный вами адрес&nbsp;
                  {get(form, 'email.value', '')}
                </span>
              </div>
            </div>
          )}
          {isShowUserEmail && !isFakeUserEmail && (
            <span>{userEmail}</span>
          )}
          <Form
            action={`/api/change-email/`}
            method="POST"
            fetchParams={{ apiVersion: 4 }}
            extraClassName="jest-user-email-update-form"
            onSubmit={(callback) => this.handleSubmit(callback)}
            onSuccess={(data) => this.handleSuccess(data)}
            onError={(errorList) => this.handleError(errorList)}>
            {isShowEmailInput && (
              <FormRow>
                <FormTextInput
                  extraClassName={classNames('jest-user-email-input', styles.input)}
                  validationMessageExtraClassName="jest-update-email-error"
                  errorList={errorList.email}
                  isDisabled={false}
                  label="Укажите свой новый адрес"
                  onUpdate={(input) => this.updateFormField(input)}
                  name="email"
                  value="" />
              </FormRow>
            )}
            {isShowCountDownTimer && (
              <FormControl>
                <Button
                  type="submit"
                  extraClassName={styles.countDownButtonTimer}
                  theme="secondary"
                  size="small"
                  isDisabled>
                  <span>
                    Повторная отправка через&nbsp;
                    <CountdownTimer
                      count={30}
                      onTimerFinished = {() => this.handleTimerFinished()} />
                    &nbsp;сек.
                  </span>
                </Button>
              </FormControl>
            )}
            {isShowResendButton && (
              <FormControl>
                <Button
                  type="submit"
                  extraClassName="jest-user-email-resend-form-submit"
                  theme="secondary"
                  size="small"
                  handleClick={() => { this.handleResendMail(); }}
                  isInProgress={isInProgress}>
                  Отправить повторно
                </Button>
              </FormControl>
            )}
            <FormControl>
              <Button
                type="submit"
                extraClassName="jest-user-email-form-submit"
                theme="secondary"
                size="small"
                isDisabled={isInProgress}
                isInProgress={isInProgress && !isFinished}>
                {(isFakeUserEmail && !isShowUserEmail) ? 'Добавить' : 'Изменить'}
              </Button>
            </FormControl>
          </Form>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
    UserActions: bindActionCreators(UserActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(UserSettingsEmail);
